import React, { FC } from "react";
import injectSheet from "react-jss";
import styleSheet from "./styles";

const TableBody: FC<any> = props => {
  return (
    <div id="table-body" className={props.classes.body}>
      {props.children}
    </div>
  );
};

export default injectSheet(styleSheet)(TableBody);
